// Trading and Vision are reserved for Pro & Enterprise subscribers.
// During the 7-day trial, user.plan is already "pro", so trials are covered.
// Admins always keep full access.
export const PREMIUM_PLANS = ["pro", "ultra"];
export const PREMIUM_ROUTES = ["/trading", "/vision", "/football"];

export function hasPremium(user) {
  if (!user || typeof user !== "object") return false;
  if (user.role === "admin") return true;
  return PREMIUM_PLANS.includes(user.plan);
}
